import { FunctionComponent, useState } from "react";

interface WhatsappButtonProps {
    
}
 
const WhatsappButton: FunctionComponent<WhatsappButtonProps> = () => {
    
    const [isActive, setIsActive] = useState<boolean>(false);

    function handleSubmit(e: any) {
        let nombre = encodeURI(e.target.nombre.value);
        let mensaje = encodeURI(e.target.mensaje.value);
        window.open(
            `https://wa.me/+5491131673437?text=Hola%21+Mi+nombre+es+${nombre}, Mensaje: ${mensaje}`,
            '_blank' // <- This is what makes it open in a new window.
          );
    }

    function handleClick() {
        if(isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    return ( 
        <div className="whatsapp_button no-select" > 
            <div className="wsp_button" onClick={handleClick}>
                <img src="./assets/images/ws_logo.webp" alt="Whatsapp Logo"/>
            </div>
            <div className={isActive ? 'form_container active' : 'form_container'}>
                <form onSubmit={handleSubmit} className="form">
                    <label htmlFor="nombre">Nombre</label>
                    <input type="text" name="nombre" id="nombre" required placeholder="Juan Perez"/>
                    <label htmlFor="mensaje">Mensaje</label>
                    <textarea name="mensaje" id="mensaje" placeholder="Escribe aquí tu mensaje..."></textarea>
                    <div className="button_container">
                        <span>Para cerrar este formulario, clickea de nuevo el botón del logo de WhatsApp</span>
                        <button type="submit" className="button success">Chatea con nosotros</button>
                    </div>
                </form>
            </div>
        </div>
     );
}
 
export default WhatsappButton;